module.exports = __webpack_public_path__ + "static/media/courses.221f72ba.svg";